<template>
  <div style="margin-left: 5px" class="float-right">
    <div class="modal fade" id="kapaMonitoringsSettings" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                aria-hidden="true">&times;</span></button>
            <h4 class="modal-title" id="myModalLabel">KaPa Monitoring Einstellungen</h4>
          </div>
          <div class="modal-body">
            <label for="">E-Mail für Benachrichtigungen</label>
            <input type="text" v-model="form.alert_recipients" class="form-control">
            <label for="">Schwellenwert</label>
            <div class="input-group">
              <input type="number" v-model="form.threshold" class="form-control" aria-describedby="basic-addon2">
              <span class="input-group-addon" id="basic-addon2">%</span>
            </div>
            <label for="">Überprüfung starten nach</label>
            <div class="input-group">
              <input type="number" v-model="form.execute_after_min" class="form-control"
                     aria-describedby="basic-addon2">
              <span class="input-group-addon" id="basic-addon2">Minuten</span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">abbrechen</button>
            <button type="button" class="btn btn-primary" @click="updateSettings">speichern</button>
          </div>
        </div>
      </div>
    </div>
    <vue-toastr ref="notificationToast"></vue-toastr>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
export default {
  name: "KapaMonitoringSettings",
  props: ['settings'],
  components: {
    VueToastr
  },
  data() {
    return {
      form: {
        alert_recipients: '',
        threshold: '',
        execute_after_min: '',
      }
    }
  },
  created() {
    this.setData();
  },
  methods: {
    setData() {
      if (this.settings) {
        this.form.alert_recipients = this.settings.alert_recipients;
        this.form.threshold = this.settings.threshold;
        this.form.execute_after_min = this.settings.execute_after_min;
      }
    },
    updateSettings() {
      axios.post('/backend/kapa-monitoring/settings/update', this.form).then(() => {
        $('#kapaMonitoringsSettings').modal('hide')
        this.$refs.notificationToast.s('Einstellungen gespeichert', 'Erfolgreich');
      })
    },
  },
}
</script>

<style scoped>
.modal-body {
  text-align: unset;
}
</style>
